import React, { useContext, useEffect, useState } from 'react'
import { CButton, CCard } from '@coreui/react'
import { raiseToast } from '../../../utils/helper'
import useAxios from 'axios-hooks'
import { AUDIENCE_API } from '../../../utils/urls'
import { AppContext } from '../../../context/app'
import { isEmpty } from 'lodash'
import InfiniteScroll from 'react-infinite-scroll-component'
import AssetFilter from '../../AssetManager/AssetFilter'
import EditIcon from '../../../../assets/edit-svg-black.svg'
import AddIcon from '../../../../assets/addnew-icon2.svg'
import FormListCard from '../../customForms/formListCard'
import { PAGE_SIZE } from 'src/views/utils/constants'
import AudienceNameModal from './audienceNameModal'
import { useHistory } from 'react-router-dom'

const CampaignAudience = () => {
  const [audienceData, setAudienceData] = useState([])
  const [searchText, setSearchText] = useState('')
  const [nameModal, setNameModal] = useState(false)
  const { setLoader } = useContext(AppContext)
  const [page, setPage] = useState(1)
  const history = useHistory()

  const [{ data: audienceList, loading: audienceListLoading }, audienceListCall] = useAxios(
    {
      url: AUDIENCE_API,
      method: 'get',
    },
    { manual: true },
  )

  const [{ data: audienceUpdate, loading: audienceUpdateLoading }, audienceUpdateCall] = useAxios(
    {
      url: AUDIENCE_API,
      method: 'put',
    },
    { manual: true },
  )

  useEffect(() => {
    audienceListCall({
      params: {
        page: 1,
        page_size: PAGE_SIZE,
      },
    })
  }, [])

  useEffect(() => {
    setLoader(audienceListLoading || audienceUpdateLoading)
  }, [audienceListLoading, audienceUpdateLoading])

  useEffect(() => {
    if (audienceList && audienceList.success) {
      page === 1
        ? setAudienceData(audienceList.data)
        : setAudienceData((campaignData) => [...campaignData, ...audienceList.data])
    }
  }, [audienceList])

  useEffect(async () => {
    if (audienceUpdate && audienceUpdate.success) {
      await audienceListCall({
        params: {
          page: page,
          page_size: PAGE_SIZE,
          search_text: searchText,
        },
      })
      raiseToast('success', 'Campaign Audience Status Updated Successfully!')
    }
  }, [audienceUpdate])

  const handleStatus = (status, id) => {
    audienceUpdateCall({
      params: {
        audience_id: id,
      },
      data: { status: status },
    })
  }

  const handleNextPage = () => {
    audienceListCall({
      params: {
        page: page + 1,
        page_size: PAGE_SIZE,
      },
    })
    setPage((page) => page + 1)
  }

  const handleSearch = (value) => {
    setPage(1)
    setSearchText(value)
    audienceListCall({
      params: { page: 1, page_size: PAGE_SIZE, search_text: value },
    })
  }

  const handleEdit = (info) => {
    history.push(`/campaign/audience/edit/${info._id}`)
  }

  return (
    <>
      <div className="d-flex justify-content-between align-items-center mt-4">
        <div>
          <h4>Campaign Audience</h4>
          <p>Following are the Campaign Audience which are already in your store.</p>
        </div>
        <CButton
          className="text-white px-3"
          onClick={() => {
            setNameModal(true)
          }}
          style={{ pointerEvents: 'auto', fontSize: '18px', background: '#20211c' }}
        >
          + Add Campaign Audience
        </CButton>
      </div>
      <div
        className="d-flex justify-content-center align-items-center "
        style={{
          padding: '0.42vw 0vw 0',
          margin: '0 auto 2vh',
          width: '100%',
        }}
      >
        <div>
          <AssetFilter
            onSearch={handleSearch}
            dropdownHeight={'300px'}
            disableFilter={true}
            searchStyle={{ background: '#fff' }}
          />
        </div>
      </div>
      <CCard>
        <div>
          <div id="scrollableDiv" className="asset-manager-card position-relative">
            <InfiniteScroll
              dataLength={audienceData.length} //This is important field to render the next data
              next={handleNextPage}
              hasMore={audienceList && audienceList.total > page * 20}
              style={{ overflowX: 'hidden' }}
              loader={<p>Loading...</p>}
              className="scrollbar-class"
              height={`65vh`}
              scrollableTarget="scrollableDiv"
            >
              <div
                className="d-flex px-2 justify-content-center align-items-center w-100 bg-black text-white position-absolute"
                style={{
                  fontSize: 'max(0.63vw,10px)',
                  paddingTop: '2px',
                  paddingBottom: '2px ',
                  top: '0',
                  zIndex: '10',
                }}
              >
                <div style={{ width: '100%' }} className="d-flex align-items-center">
                  <div style={{ marginBlockEnd: '0', width: '25%' }} className="pl-2">
                    Audience Name
                  </div>
                  <div style={{ marginBlockEnd: '0', width: '25%' }}>Description</div>
                  <div style={{ marginBlockEnd: '0', width: '25%' }}>Audience Type</div>
                  <div style={{ marginBlockEnd: '0', width: '25%' }}>Static/Dynamic</div>
                  <div style={{ marginBlockEnd: '0', width: '12%', textAlign: 'center' }}>
                    Status
                  </div>
                  <div style={{ width: '5%' }} />
                </div>
              </div>

              <div
                className="d-flex flex-wrap"
                style={{
                  gap: '1.2vw 0',
                  padding: '30px 8px 20px 8px',
                }}
              >
                {!isEmpty(audienceData)
                  ? audienceData.map((info, index) => {
                      return (
                        <FormListCard
                          cardImage={''}
                          cardImgWidth="0%"
                          disableCardImg={true}
                          textData={[
                            {
                              name: info?.name,
                              styles: {
                                overflow: 'hidden',
                                fontWeight: '600',
                                fontSize: '14px',
                                width: '25%',
                                paddingLeft: '10px',
                              },
                            },
                            {
                              name: info?.description,
                              styles: { width: '25%' },
                            },
                            {
                              name: info?.audience_type,
                              styles: { width: '25%' },
                            },
                            {
                              name: info.is_static ? 'Static' : 'Dynamic',
                              styles: { width: '25%' },
                            },
                          ]}
                          key={index}
                          status={info?.status}
                          statusCallback={(value) => {
                            handleStatus(value, info._id)
                          }}
                          actionButtonOptions={[
                            {
                              name: 'Edit',
                              btnFunction: () => handleEdit(info),
                              logo: (
                                <div className="flex mr-1">
                                  <img style={{ width: '10px' }} src={EditIcon} alt={'editIcon'} />
                                </div>
                              ),
                            },
                          ]}
                          actionButtonWidth="5%"
                        />
                      )
                    })
                  : null}

                <div
                  style={{
                    width: '100%',
                    aspectRatio: '1506/71',
                    boxShadow: ' 3px 3px 6px 0 rgba(0, 0, 0, 0.16)',
                    display: 'flex',
                    background: '#ececec',
                    fontSize: '0.833vw',
                    fontWeight: 550,
                  }}
                  className={`rounded-1 cursor-pointer d-flex flex-col justify-content-center align-items-center`}
                  onClick={() => {
                    setNameModal(true)
                  }}
                >
                  <img
                    src={AddIcon}
                    alt="AddIcon"
                    className=""
                    style={{ width: '1.25vw', height: '1.25vw' }}
                  />
                  <span className="">Add New Campaign Audience</span>
                </div>
              </div>
            </InfiniteScroll>
          </div>
        </div>
      </CCard>
      {nameModal && (
        <AudienceNameModal
          onCancel={() => {
            setNameModal(false)
          }}
          onSave={(value) => {
            history.push({ pathname: '/campaign/audience/create', state: { name: value } })
            setNameModal(false)
          }}
        />
      )}
    </>
  )
}

export default CampaignAudience
